
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import config from '@/config/index'

import { wxShare, getWxConfig } from '@/libs/utils.js'
import errorImg from '@/assets/mall/img-error.png'
import { getProductDetail } from '@/api/jianianhua'
export default {
name: 'productdetail',
components: {
XButton,
Divider,
Swiper
},
data () {
return {
searchVal: '',
baseUrl: config.baseUrl,
errorImg: errorImg,
id: this.$route.params.id,
goodsObj: {},
flag: false
}
},
created () {
this.getDetail()
},
methods: {
onImgError ($event) {
$event.target.src = this.errorImg
},
getDetail () {
getProductDetail({
id: this.id
}).then(res => {
this.goodsObj = res.obj
this.flag = this.compareDate(res.obj.startdate, res.obj.enddate)
const link = window.location.href
const wxShareLink = this.baseUrl + 'servlet/ShareServlet?sicode=' + config.sicode + '&url=' + link
wxShare(res.obj.prodname, wxShareLink, this.baseUrl + res.obj.filePath)
})
},
compareDate (d1, d2) {
var startDate = new Date(d1.replace(/-/g, '\/'))
var currentDate = new Date()
var enddate = new Date(d2.replace(/-/g, '\/'))
return Date.parse(startDate) < Date.parse(currentDate) && Date.parse(currentDate) < Date.parse(enddate)
},
confirm () {
this.$router.push({ name: 'jianianhuaconfirm', params: { productid: this.id } })
}
}
}
